type Site =
  | 'datadoghq.com'
  | 'datadoghq.eu'
  | 'us3.datadoghq.com'
  | 'us5.datadoghq.com'
  | 'ap1.datadoghq.com'
  | 'ddog-gov.com';
import { STORAGE_KEY } from './const';

const SeparateSocket = () => {
  // 20 로버트_셀러
  // 319251 야로2
  // 319152 벤
  // ---
  // 48134 : 쓰리백
  const localTester = [20, 319251, 319152];
  const userIndex = [...localTester, 48134];

  const loginUserId = localStorage.getItem(STORAGE_KEY.clickI) ?? '-1';
  // 쓰리백 대응
  if (userIndex.includes(Number(loginUserId))) {
    return 'https://prod-broadcast-threebak-api.clickmate.link';
  } else {
    return process.env.REACT_APP_SOCKET_URL as string;
  }
};

const env = {
  NODE_ENV: process.env.REACT_APP_NODE_ENV as string,
  BASE_URL: process.env.REACT_APP_BASE_URL as string,
  PLAYER_URL: process.env.REACT_APP_PLAYER_URL as string,
  SOCKET_URL: SeparateSocket(),
  CS_SOCKET_URL: process.env.REACT_APP_CS_SOCKET_URL as string,
  ADMIN_URL: process.env.REACT_APP_ADMIN_URL as string,
  VERSION: process.env.REACT_APP_APP_VERTION as string,
  SAVE_KEY: process.env.REACT_APP_SAVE_KEY as string,
  LIVE_LIST_SRC: process.env.REACT_APP_LIVE_LIST_SRC as string,
  LIVE_DETAIL_SRC: process.env.REACT_APP_LIVE_DETAIL_SRC as string,
  TALK_PLUS_APP_ID: process.env.REACT_APP_TALK_PLUS_APP_ID as string,
  AUTH_FILE: process.env.REACT_APP_AUTH_FILE as string,
  FIREBASE: {
    API_KEY: process.env.REACT_APP_FIREBASE_API_KEY as string,
    AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN as string,
    PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID as string,
    STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET as string,
    MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID as string,
    APP_ID: process.env.REACT_APP_FIREBASE_APP_ID as string,
    MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID as string,
    VAPID_KEY: process.env.REACT_APP_FIREBASE_VAPID_KEY as string,
  },
  DATADOG: {
    APPLICATION_ID: process.env.REACT_APP_DATADOG_APPLICATION_ID as string,
    TOKEN: process.env.REACT_APP_DATADOG_TOKEN as string,
    SITE: process.env.REACT_APP_DATADOG_SITE as Site,
    SERVICE: process.env.REACT_APP_DATADOG_SERVICE as string,
  },
};

export default env;
